import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';

export default {
  data: function data() {
    return {
      timeId: 0,
      isOvertime: false
    };
  },


  computed: _extends({}, mapState({
    templateState: function templateState(state) {
      return state.creative.template.templateState;
    }
  }), {
    saving: function saving() {
      return this.templateState === 'saving';
    },
    savedSuccessfully: function savedSuccessfully() {
      return this.templateState === 'saved-successfully';
    }
  }),

  watch: {
    savedSuccessfully: function savedSuccessfully(val) {
      var _this = this;

      if (val === true) {
        clearTimeout(this.timeId);
        this.isOvertime = false;
        // 保存成功后三秒将状态改为 editing
        // 因为没有必要一直展示保存状态
        // 可以优化成如果资源或配置有变化后再更新，暂时没有时间
        setTimeout(function () {
          _this.isOvertime = true;
        }, 3000);
      }
    }
  },

  mounted: function mounted() {},


  methods: {}
};